import { BackdropSchema } from "../../Backdrop";
import { BladeCommonSchema } from "../../../types";
import { BladeHeaderSchema } from "../../BladeHeader";
export const BasicBladeSchema = BladeCommonSchema.extend({
    backdrop: BackdropSchema.optional(),
    header: BladeHeaderSchema.optional(),
});
//# sourceMappingURL=index.js.map